<template>
  <div class="frontpage">
    <Header :loggedIn="false" />
    <div class="container">
      <div
        v-if="userError"
        class="error-block"
        v-t="`api_errors.${userError}`"
      ></div>
    </div>
  </div>
</template>
<script>
import Header from '@/components/Header';
import { mapState } from 'vuex';
export default {
  components: {
    Header,
  },
  computed: {
    ...mapState('user', ['userError']),
  },
};
</script>
